import {Injectable} from '@angular/core';

// TODO unify return types
export abstract class PersistenceService {

    public abstract setItem(key: string, value: string): void;

    public abstract setObjectItem(key: string, value: object): void;

    public abstract getItem(key: string): string | null;

    public abstract getObjectItem(key: string): object | null;

    public abstract removeItem(key: string): void;

    public abstract setSessionItem(key: string, value: string): void;

    public abstract setSessionObjectItem(key: string, value: object): void;

    public abstract getSessionItem(key: string): string | null;

    public abstract getSessionObjectItem(key: string): object | null;

    public abstract removeSessionItem(key: string): void;

}

@Injectable()
export class BrowserPersistenceService extends PersistenceService {

    constructor() {
        super();
    }

    public setItem(key: string, value: string) {
        localStorage.setItem(key, value);
    }

    public setObjectItem(key: string, value: object) {
       localStorage.setItem(key, JSON.stringify(value));
    }

    public getItem(key: string): string | null {
        return localStorage.getItem(key);
    }

    public getObjectItem(key: string): object | null {
        const item = localStorage.getItem(key);
        return item ? JSON.parse(item) : null;
    }

    public removeItem(key: string) {
        localStorage.removeItem(key);
    }

    public setSessionItem(key: string, value: string) {
        sessionStorage.setItem(key, value);
    }

    public setSessionObjectItem(key: string, value: object) {
        sessionStorage.setItem(key, JSON.stringify(value));
    }

    public getSessionItem(key: string): string | null {
        return sessionStorage.getItem(key);
    }

    public getSessionObjectItem(key: string): object | null {
        const item = sessionStorage.getItem(key);
        return item ? JSON.parse(item): null;
    }

    public removeSessionItem(key: string) {
        sessionStorage.removeItem(key);
    }

}
